import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Button, Box } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { DateInput } from "../../../utils/commonComponent/Custom/custominput";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
// import { certQuery } from "../../certificates/certQuery";
import { dsQuery } from "../../datasheet/query";
import moment from "moment/moment";
import ExcelDownload from "../../../utils/commonComponent/ExcelDownload";
import { AddButton } from "../../../utils/commonComponent/Custom/Button";
import { getPermissions } from "../../rbac/hasAccess";
import { getFormattedDates } from "../../../utils/utils";

let notNeededColumn = ["id"];

const SummaryReport = (props) => {
  const permissions = getPermissions(props.moduleId);  
  const [labRefOptions, setLabRefOptions] = useState([]);
  const [selectedLabs, setSelectedLabs] = useState([]);
  const [summaryReport, setSummaryReport] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searched, setSearched] = React.useState(false);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalRecords, setTotalRecords] = useState(0);
  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  useEffect(() => {
    const fetchLabRefs = async () => {
      try {
        const query = `SELECT DISTINCT inward.id AS inward_id, inward.labReferenceNo AS inward_labReferenceNo FROM inward WHERE inward.labReferenceNo IS NOT NULL   AND inward.labReferenceNo != '-'  AND inward.status != -1 ORDER BY inward.id DESC;`;
        const result = await fetchQuery(query);
        const refs = result
          .filter((row) => row.inward_labReferenceNo?.trim())
          .map((row) => ({
            id: row.inward_id,
            label: row.inward_labReferenceNo.trim(),
          }));
        setLabRefOptions(refs);
      } catch (error) {
        console.error("Error fetching lab references:", error);
      }
    };

    fetchLabRefs();
  }, []);

  const handleSearch = async () => {
    try {
      const selectedRefs = selectedLabs.map((lab) => lab.label);

      const selectedRefsSql = selectedRefs.map((ref) => `'${ref}'`).join(",");

      const offset = currentPage * rowsPerPage;

      let baseQuery = `${dsQuery} WHERE 1=1 AND certificate.status != -1`;

      if (selectedRefsSql) {
        baseQuery += ` AND inward.labReferenceNo IN (${selectedRefsSql})`;
      }

      if (fromDate && toDate) {
        const { from, to } = getFormattedDates(fromDate, toDate);
        baseQuery += ` AND DATE(observationSheet.startTestingDate) >= '${from}' AND DATE(observationSheet.endTestingDate) <= '${to}'`;
      }

      baseQuery += ` ORDER BY certificate.id DESC`;

      const query = `${baseQuery} LIMIT ${rowsPerPage} OFFSET ${offset};`;

      const countQuery = `SELECT COUNT(*) AS total FROM (${baseQuery}) AS subquery;`;

      const [data, countData] = await Promise.all([
        fetchQuery(query),
        fetchQuery(countQuery),
      ]);

      const filteredData = (data || []).map((row) => ({
        inward_customerName: row.inward_customerName || "-",
        materialScope_MaterialName: row.materialScope_MaterialName || "-",
        materialTestings_testName: row.materialTestings_testName || "-",
        jobRegister_jobNumber: row.jobRegister_jobNumber || "-",
        inward_labReferenceNo: row.inward_labReferenceNo || "-",
        observationSheet_testNumber: row.observationSheet_testNumber || "-",
        certificate_ulrNumber: row.certificate_ulrNumber || "-",
        certificate_reportNumber: row.certificate_reportNumber || "-",
        start_Date: row.observationSheet_startTestingDate ? moment(row.observationSheet_startTestingDate).format("DD/MM/YYYY") : "-",
        end_Date: row.observationSheet_endTestingDate ? moment(row.observationSheet_endTestingDate).format("DD/MM/YYYY") : "-",
        testedBy_userName: row.testedBy_userName || "-",
        reviewedBy_userName: row.reviewedBy_userName || "-",
        authorizedBy_userName: row.authorizedBy_userName || "-",
      }));

      setSummaryReport(filteredData);
      setTotalRecords(countData?.[0]?.total || 0);
      setSearched(true);
    } catch (error) {
      console.error("Error fetching summary report:", error);
    }
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: "l",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const title = "Summary Report";
    doc.setFontSize(14);
    const textWidth = doc.getTextWidth(title);
    const x = (pageWidth - textWidth) / 2;
    doc.text(title, x, 15);

    const tableColumn = [
      "Sr.No.",
      "Customer Name",
      "Material Name",
      "Test Name",
      "Job Number",
      "Lab Ref No",
      "Test No",
      "ULR No",
      "Report No",
      "Start Date",
      "End Date",
      "Tested By",
      "Reviewed By",
      "Authorized By",
    ];

    const tableRows = summaryReport.map((row, index) => [
      index + 1,
      row.inward_customerName,
      row.materialScope_MaterialName,
      row.materialTestings_testName,
      row.jobRegister_jobNumber,
      row.inward_labReferenceNo,
      row.observationSheet_testNumber,
      row.certificate_ulrNumber,
      row.certificate_reportNumber,
      row.start_Date,
      row.end_Date,
      row.testedBy_userName,
      row.reviewedBy_userName,
      row.authorizedBy_userName,
    ]);

    autoTable(doc, {
      startY: 28,
      head: [tableColumn],
      body: tableRows,
      styles: {
        fontSize: 8,
        halign: "center",
        valign: "middle",
        textColor: 0,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        cellPadding: 2,
      },
      headStyles: { fillColor: false },
      margin: { left: 12, right: 12, bottom: 12 + 10 },
      theme: "grid",
    });

    //  Add page numbers (01 of 05) at top right
    const totalPages = doc.internal.getNumberOfPages();
    for (let page = 1; page <= totalPages; page++) {
      doc.setPage(page);
      const pageText = `Page No: ${String(page).padStart(2, "0")} of ${String(
        totalPages
      ).padStart(2, "0")}`;
      doc.setFontSize(8);
      doc.text(pageText, pageWidth - 70, 20); // right side top
    }

    doc.save(`Summary_Report.pdf`);
  };

  const clearSearch = () => {
    setSummaryReport([]);
    setTotalRecords(0);
    setSearched(false);
    setFromDate(null);
    setToDate(null);
    setSelectedLabs([]);
  };

  const isDisabled = !((fromDate && toDate) || selectedLabs.length > 0);

  if(!permissions?.view) return;

  return (
    <div>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" sx={{ width: "100%", p: 1,}}>
        <Box flexBasis="30%">
          <Autocomplete
            multiple
            size="small"
            options={[{ id: "all", label: "Select All" }, ...labRefOptions]}
            value={selectedLabs}
            onChange={(_, value) => {
              const isSelectAllChosen = value.some((v) => v.id === "all");
              if (isSelectAllChosen) {
                // If all already selected, then clear all
                if (selectedLabs.length === labRefOptions.length) {
                  setSelectedLabs([]);
                } else {
                  // Otherwise select all (exclude the "Select All" option itself)
                  setSelectedLabs(labRefOptions);
                }
              } else {
                // Regular multi-selection
                setSelectedLabs(value);
              }
             setSearched(false);
            }}
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, value) =>
              String(option?.id) === String(value?.id)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Lab Reference No"
                placeholder="Select lab refs"
                size="small"
              />
            )}
            limitTags={1}
            fullWidth
          />
        </Box>

        <Box flexBasis="10%">
          <DateInput label="From Date" value={fromDate} onChange={(d) => {
              setFromDate(d);
              setSearched(false);
            }}
          />
        </Box>

        <Box flexBasis="10%">
          <DateInput label="To Date" value={toDate} onChange={(d) => {
              setToDate(d);
              setSearched(false);
            }}
          />
        </Box>

        <Box flexBasis="10%">
          <Button
            variant="contained"
            color={searched ? "error" : "primary"}
            disabled={isDisabled}
            onClick={() => searched ? clearSearch() : handleSearch()}
            fullWidth
            sx={{
              textTransform: "none",
              height: "40px",
            }}
          >
            {searched ? "Clear" : "Search"}
          </Button>
        </Box>

        {summaryReport?.length > 0 && (
          <Box flexBasis="30%" display="flex" gap={1}>
            {permissions?.excelDownload && (
              <ExcelDownload
                finalData={summaryReport}
                notNeededColumn={notNeededColumn}
              />
            )}
            {permissions?.pdfDownload && (
              <AddButton
                id="btn-add-outline"
                label="Download PDF"
                onClick={handleDownloadPDF}
              />
            )}
          </Box>
        )}
      </Box>

      <div className="w-full border rounded-md shadow">
        {/* Table Container */}
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Sr. No.</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Customer Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Material Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Test Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Job Number</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Lab Ref No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Test No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">ULR No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Report No</th>              
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Start Date</th>              
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">End Date</th>              
                <th className="px-4 py-3 text-center">Tested By</th>
                <th className="px-4 py-3 text-center">Reviewed By</th>
                <th className="px-4 py-3 text-center">Authorized By</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {summaryReport.map((row, index) => {
                return (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-center">{currentPage * rowsPerPage + index + 1}</td>
                    <td className="px-4 py-2 text-center">{row.inward_customerName}</td>
                    <td className="px-4 py-2 text-center">{row.materialScope_MaterialName}</td>
                    <td className="px-4 py-2 text-center">{row.materialTestings_testName}</td>
                    <td className="px-4 py-2 text-center">{row.jobRegister_jobNumber}</td>
                    <td className="px-4 py-2 text-center">{row.inward_labReferenceNo}</td>
                    <td className="px-4 py-2 text-center">{row.observationSheet_testNumber}</td>
                    <td className="px-4 py-2 text-center">{row.certificate_ulrNumber}</td>
                    <td className="px-4 py-2 text-center">{row.certificate_reportNumber}</td>
                    <td className="px-4 py-2 text-center">{row.start_Date}</td>
                    <td className="px-4 py-2 text-center">{row.end_Date}</td>
                    <td className="px-4 py-2 text-center">{row.testedBy_userName}</td>
                    <td className="px-4 py-2 text-center">{row.reviewedBy_userName}</td>
                    <td className="px-4 py-2 text-center">{row.authorizedBy_userName}</td>
                  </tr>
                );
              })}

              {summaryReport.length === 0 && (
                <tr>
                  <td colSpan={12} className="text-center py-4 text-gray-500">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-2 py-1 text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                    (currentPage + 1) * rowsPerPage,
                    totalRecords
                  )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryReport;